<script lang="ts" setup>
import { computed, onMounted, ref, watch } from "vue";
import ChooseSource from "./chooseSource.vue";
import { message } from "@/utils/message";
import { uploadFile } from "@/utils/qiniu";
import { fetchCommonOCR, fetchCompanyOcr, fetchIdcardOcr } from "@/api/file";
import { getServerFile } from "@/utils/image";
import { ImageAssets } from "@/assets/images";
import { emitter } from "@/utils/mitt";

const emit = defineEmits(["update:modelValue", "choose"]);
const props = defineProps({
  title: String,
  code: String,
  isApp: Boolean
});
const show = ref(false);
const showIdcard = ref(false);
const showCompany = ref(false);
const idcardLoading = ref(false);
const companyLoading = ref(false);
const chooseItem = (item: any) => {
  emit("choose", item);
};
const showList = () => {
  show.value = true;
  emit("update:modelValue", Date.now().toString());
};
const getValueByName = (name: string, data: any) => {
  const findItem = data.find(item => item.Name === name);
  if (findItem) {
    return findItem.Value;
  }
  return "";
};
const chooseCompanyImage = async () => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/*";
  input.onchange = async e => {
    let ocrImage = input.files[0];
    companyLoading.value = true;
    try {
      const res = await uploadFile(ocrImage, "ocrImages");
      const ocrResult = await fetchCompanyOcr(getServerFile(res.data.path));
      if (!ocrResult.success) {
        message(ocrResult.message, { type: "error" });
        return;
      }
      const ocrData = ocrResult?.data?.EnterpriseLicenseInfos;
      if (!ocrData) {
        message("证件识别失败，未读取到数据", { type: "warning" });
        return;
      }
      emit("choose", {
        companyName: getValueByName("名称", ocrData),
        companyAddress:
          getValueByName("住所", ocrData) ||
          getValueByName("办公场所", ocrData),
        companyCertNo: getValueByName("统一社会信用代码", ocrData),
        businessLicense: getServerFile(res.data.path)
      });
      message("证件识别成功", { type: "success" });
    } catch (e) {
      message(e.message || "识别失败", { type: "error" });
    } finally {
      companyLoading.value = false;
    }
  };
  input.click();
};
const chooseIdcardImage = async () => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/*";
  input.onchange = async e => {
    let ocrImage = input.files[0];
    idcardLoading.value = true;
    try {
      const res = await uploadFile(ocrImage, "ocrImages");
      const ocrResult = await fetchIdcardOcr(getServerFile(res.data.path));
      if (!ocrResult.success) {
        message(ocrResult.message, { type: "error" });
        return;
      }
      const ocrData = ocrResult?.data;
      if (!ocrData) {
        message("证件识别失败，未读取到数据", { type: "warning" });
        return;
      }
      emit("choose", {
        sqrName: ocrData.Name,
        sqrCertType: "身份证",
        sqrID: ocrData.IdNum,
        sqrIdCardFront: getServerFile(res.data.path),
        sqrAddress: ocrData.Address
      });
      message("身份证识别成功", { type: "success" });
    } catch (e) {
      message(e.message || "识别失败", { type: "error" });
    } finally {
      idcardLoading.value = false;
    }
  };
  input.click();
};
const chooseImage = () => {
  emit("update:modelValue", Date.now().toString());
  if (props.code === "Personal") {
    showIdcard.value = true;
  } else if (props.code === "Company") {
    showCompany.value = true;
  } else if(props.code === "UserProperty"){
    smartOcr();
  }
};
const showChooseBtn = computed(() => {
  return props.code !== "UserProperty";
});
const getSmartOrcValue = (field: string, data: any[]) => {
  for(let item of data){
    if(item.Name === field){
      return item.Value || "";
    }
  }
  return "";
}
const smartTypeSwicth = (arr: string[]) => {
  const fields = {
    "国有建设用地使用权": "国有土地使用证",
    "房屋所有权": "房屋所有权证",
  }
  return arr.map(item => fields[item] || item);
}
const smartOcr = () => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/*";
  input.onchange = async e => {
    let ocrImage = input.files[0];
    idcardLoading.value = true;
    try {
      const res = await uploadFile(ocrImage, "ocrImages");
      if (res.code !== 0) {
        message(res.message, { type: "error" });
        return;
      }
      emitter.emit("businessFileChange", res);
      const ocrResult = await fetchCommonOCR(getServerFile(res.data.path));
      if (!ocrResult.success) {
        message(ocrResult.message, { type: "error" });
        return;
      }
      const ocrData = ocrResult?.data;
      if (!ocrData) {
        message("证件识别失败，未读取到数据", { type: "warning" });
        return;
      }
      let titleName = getSmartOrcValue("标题", ocrData.StructuralItems || []) || getSmartOrcValue("机构", ocrData.StructuralItems || []);
      if(titleName === "不动产权证书"){
        console.log("是不动产");
        emit("choose", {
          propertyType: "不动产",
          budong: {
            propAddr: getSmartOrcValue("坐落", ocrData.StructuralItems || []),
            certType: smartTypeSwicth(getSmartOrcValue("权利类型", ocrData.StructuralItems || []).split("/")),
            certNo: getSmartOrcValue("证字号", ocrData.StructuralItems || []),
          }
        });
      }else if(titleName.indexOf("银行") > -1){
        console.log("是银行");
        emit("choose", {
          propertyType: "资金财产",
          zican: {
            fundType: "银行存款",
            depositCert: {
              certType: "银行卡",
              acctNo: getSmartOrcValue("号码", ocrData.StructuralItems || []),
            }
          }
        });
      }else if(titleName.indexOf("机动车行驶证") > -1){
        console.log("是机动车");
        emit("choose", {
          propertyType: "车辆",
          car: {
            vehAttr: "行驶证",
            ownerName: getSmartOrcValue("所有人", ocrData.StructuralItems || []),
            plateNo: getSmartOrcValue("号牌号码", ocrData.StructuralItems || []),
            vehType: getSmartOrcValue("车辆类型", ocrData.StructuralItems || []),
            vehBrand: getSmartOrcValue("品牌型号", ocrData.StructuralItems || []),
            vin: getSmartOrcValue("车辆识别代号", ocrData.StructuralItems || []),
          }
        });
      }else if(titleName.indexOf("注册登记机动车信息栏") > -1){
        console.log("是机动车");
        emit("choose", {
          propertyType: "车辆",
          car: {
            vehAttr: "机动车登记证书",
            ownerName: "",
            plateNo: "",
            vehType: getSmartOrcValue("车辆类型", ocrData.StructuralItems || []),
            vehBrand: getSmartOrcValue("车辆品牌", ocrData.StructuralItems || []) + getSmartOrcValue("车辆型号", ocrData.StructuralItems || []),
            vin: getSmartOrcValue("车辆识别代号/车架号", ocrData.StructuralItems || []),
          }
        });
      }else{
        emit("choose", {
          propertyType: "其他"
        });
      }
      // emit("choose", {
      //   sqrName: ocrData.Name,
      //   sqrCertType: "身份证",
      //   sqrID: ocrData.IdNum,
      //   sqrIdCardFront: getServerFile(res.data.path),
      //   sqrAddress: ocrData.Address
      // });
      message("证件识别成功", { type: "success" });
    } catch (e) {
      message(e.message || "识别失败", { type: "error" });
    } finally {
      idcardLoading.value = false;
    }
  };
  input.click();
}
</script>
<template>
  <div class="absolute right-0 flex items-center" style="top: -35px">
    <el-button size="small" v-if="showChooseBtn" @click="showList" type="primary"
      >选择{{ title }}</el-button
    >
    <el-button size="small" @click="chooseImage" type="primary"
      >证件识别</el-button
    >
    <el-dialog
      width="90%"
      :model-value="show"
      :append-to-body="true"
      title="数据列表"
      style="max-width: 450px"
      @close="() => (show = false)"
      destroy-on-close
    >
      <ChooseSource v-if="show" :code="props.code" @choose="chooseItem" />
    </el-dialog>
    <el-dialog
      :width="isApp ? '90%' : '500px'"
      v-model="showIdcard"
      :append-to-body="true"
      title="上传证件示例"
    >
      <div class="mb-4 text-center text-lg">
        请保证上传证件图片正面清晰可见，以免影响识别结果
      </div>
      <div v-loading="idcardLoading" element-loading-text="正在识别中...">
        <img :src="ImageAssets.idCardFront" class="w-full" />
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="showIdcard = false">取消</el-button>
          <el-button
            :loading="idcardLoading"
            type="primary"
            @click="chooseIdcardImage"
          >
            立即上传
          </el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      :width="isApp ? '90%' : '500px'"
      v-model="showCompany"
      :append-to-body="true"
      title="上传证件示例"
    >
      <div class="mb-4 text-center text-lg">
        请保证上传证件图片正面清晰可见，以免影响识别结果
      </div>
      <div v-loading="companyLoading" element-loading-text="正在识别中...">
        <img :src="ImageAssets.lisence" class="w-full" />
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="showCompany = false">取消</el-button>
          <el-button
            :loading="companyLoading"
            type="primary"
            @click="chooseCompanyImage"
          >
            立即上传
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
